import React from 'react';
import ReactDOM from 'react-dom/client';
import { I18nProvider } from './contexts/I18nContext';
import App from './App';
import './styles/global.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><I18nProvider><App /></I18nProvider></React.StrictMode>);
